<template>
  <div class="page">
    <list
      title="Pessoa Física"
      tag="cpf"
      subtitle="Nesta tela você cria e verifica os templates de consultas que possuem CPF como campo obrigatório."
      :create-route="{ name: 'Template-Physical-Person-Create' }"
    />
  </div>
</template>

<script>
import List from '@/template/components/List.vue';

export default {
  name: 'Index',

  components: {
    List,
  },
};
</script>

<style scoped>

</style>
